import React, { useEffect, useState, Fragment } from "react";
import "./Add.css";
import { backend, API_URL } from "../../../config";
import {
  Container,
  CssBaseline,
  Grid,
  Button,
  Modal,
  Typography,
  CircularProgress,
  TextField,
  CardMedia,
  Stack,
} from "@mui/material";

import fallbackImage from "../../../assets/images/noimage.png";

import { makeStyles } from "@mui/styles";
import { TableBase } from "../../Inventory/Inventory";

const columns = [
  {
    id: "upc",
    editable: "/product",
    editablePk: "upc",
    label: "UPC",
    target: "_blank",
  },
  {
    id: "name",
    label: "Name",
  },
];

const useStyles = makeStyles((theme) => ({
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  modal: {
    position: "absolute",
    width: 400,
    backgroundColor: "#fff",
    border: "1px solid rgba(0,0,0,.2)",
    borderRadius: ".3rem",
    boxShadow: theme.shadows[5],
    padding: "1rem",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
}));

const onMediaFallback = (e) => (e.target.src = fallbackImage);

const AddItemCode = (props) => {
  const classes = useStyles();
  const itemCodeId = props.match.params.id;

  const [confirmModal, setConfirmModal] = useState(false);
  const [errorInfo, setErrorInfo] = useState({ error: false, message: "" });
  const [itemCode, setItemCode] = useState({
    item_code: "",
    name: "",
    url: "",
    master_upc: "",
    products: [],
    override_products: [],
  });
  const [itemCodeLoaded, setItemCodeLoaded] = useState(false);

  const [responseModal, setResponseModal] = useState(false);
  const [loadingFlag, setLoadingFlag] = useState(false);
  const [finishedFlag, setFinishedFlag] = useState(false);

  const handleBack = () => {
    props.history.push("/itemcodes");
  };

  const handleChange = (e, v) => {
    const { name, value } = e.target;

    setItemCode((prevState) => ({ ...prevState, [name]: value }));
  };

  const toggleConfirmModal = () => setConfirmModal(!confirmModal);

  const confirmModalContent = (
    <div className={classes.modal}>
      {!loadingFlag && !finishedFlag ? (
        <>
          Are you sure you want to {!itemCodeId ? " update " : " add "}
          the item code <b>{itemCode.item_code.item_code}</b>
          <div align="right">
            <Button
              onClick={() => toggleConfirmModal()}
              className={classes.button}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => sendRequest()}
              className={classes.button}
            >
              Confirm
            </Button>
          </div>
        </>
      ) : loadingFlag ? (
        <>
          <div align="center">
            <CircularProgress />
            <div>
              {!itemCodeId ? " Updating item code " : " Adding item code "}
            </div>
          </div>
          {errorInfo.error ? (
            <>
              <br />
              <br />
              There was an error while
              {!itemCodeId ? " updating " : " saving "}the item code
              <br />
              <br />
              <span
                style={{
                  color: "red",
                  wordBreak: "break-word",
                  maxHeight: 160,
                  overflow: "hidden",
                  display: "inline-block",
                }}
              >
                <b>Error:</b>
                <br />
                {typeof errorInfo.message === "object" ? (
                  <>
                    <ul>
                      {Object.keys(errorInfo.message).map((key) => (
                        <li key={key}>
                          <b>{key}:</b>
                          {` ${errorInfo.message[key]}`}
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (
                  errorInfo.message
                )}
              </span>
              <div align="right">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => resolveError()}
                  className={classes.button}
                >
                  Continue
                </Button>
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      ) : (
        <>
          The item code has been{!itemCodeId ? " updated " : " added "}
          successfully
          <div align="right">
            <Button
              variant="contained"
              color="primary"
              onClick={() => resolveRequest()}
              className={classes.button}
            >
              Close
            </Button>
          </div>
        </>
      )}
    </div>
  );

  /**
   * todo: we might be able to remove the below code/functions and related occurrences in this file
   */

  const toggleResponseModal = () => setResponseModal(!responseModal);

  const responseModalContent = (
    <div className={classes.modal}>
      {errorInfo.error ? (
        <>
          There was an error
          {!itemCodeId ? " updating " : " adding "}
          the item code <b>{itemCode.api_description}</b>
          <br />
          <br />
          <span
            style={{
              color: "red",
              wordBreak: "break-word",
              maxHeight: 160,
              overflow: "hidden",
              display: "inline-block",
            }}
          >
            <b>Error:</b>
            <br />
            {errorInfo.message}
          </span>
        </>
      ) : (
        <>
          Item code <b>{itemCode.api_description}</b> has been successfully
          {!itemCodeId ? " updated " : " added "}
        </>
      )}
      <div align="right">
        <Button
          variant="contained"
          color="primary"
          onClick={() => resolveRequest()}
          className={classes.button}
        >
          Continue
        </Button>
      </div>
    </div>
  );

  const sendRequest = async () => {
    setLoadingFlag(true);

    const itemCodeObjPayload = {
      name: itemCode.name,
      url: itemCode.url,
    };

    if (itemCodeId) {
      await backend
        .patch(`${API_URL}itemcodes/${itemCodeId}`, itemCodeObjPayload)
        .then((response) => {
          setLoadingFlag(false);
          setFinishedFlag(true);
        })
        .catch((error) => {
          console.log(error);
          const errorData = error.response.data;

          setErrorInfo({
            error: true,
            message:
              typeof errorData === "object"
                ? errorData.hasOwnProperty("message")
                  ? errorData.message
                  : errorData.hasOwnProperty("message")
                  ? errorData.detail
                  : errorData
                : error.message,
          });
        });
    }
  };

  const resolveError = () => {
    toggleConfirmModal();
    setLoadingFlag(false);
    setFinishedFlag(false);
    setErrorInfo({ error: false, message: "" });
  };

  const resolveRequest = () => {
    props.history.push("/itemcodes");
  };

  useEffect(() => {
    const getItemCode = async () => {
      await backend
        .get(`${API_URL}itemcodes/${itemCodeId}`)
        .then(({ data }) => {
          setItemCode(data);
          setItemCodeLoaded(true);
        });
    };

    if (itemCodeId && !itemCodeLoaded) {
      getItemCode();
    }
  }, [itemCodeId, itemCodeLoaded]);

  return (
    <>
      <CssBaseline />
      <Container maxWidth="lg" className="container">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Modal open={confirmModal} onClose={toggleConfirmModal}>
              {confirmModalContent}
            </Modal>
            <Modal open={responseModal} onClose={toggleResponseModal}>
              {responseModalContent}
            </Modal>
            <Typography component="h6" variant="h6" align="center">
              {itemCodeId ? "Edit" : "Add"} Item Code Display
            </Typography>
            <br />
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  InputProps={{
                    inputProps: {
                      autoComplete: "off",
                    },
                  }}
                  size="small"
                  variant="outlined"
                  label="Item Code "
                  name="item_code"
                  value={(itemCode && itemCode.item_code) || ""}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  InputProps={{
                    inputProps: {
                      autoComplete: "off",
                    },
                  }}
                  size="small"
                  variant="outlined"
                  label="Description "
                  name="name"
                  value={(itemCode && itemCode.name) || ""}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  InputProps={{
                    inputProps: {
                      autoComplete: "off",
                    },
                  }}
                  size="small"
                  variant="outlined"
                  label="URL"
                  name="url"
                  value={(itemCode && itemCode.url) || ""}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12}>
                <CardMedia
                  style={{ width: "auto", height: 200 }}
                  component="img"
                  image={itemCode.url || fallbackImage}
                  alt={itemCode.name || ""}
                  onError={onMediaFallback}
                />
              </Grid>
              <Grid item xs={12}>
                {itemCode.products.length ? (
                  <>
                    <br />
                    <Typography component="h6" variant="h6" align="center">
                      Related products
                    </Typography>
                    <TableBase
                      columns={columns}
                      items={itemCode.products}
                      size="auto"
                    />
                  </>
                ) : (
                  <></>
                )}
                {itemCode.override_products.length ? (
                  <>
                    <br />
                    <Typography component="h6" variant="h6" align="center">
                      Override products
                    </Typography>
                    <TableBase
                      columns={columns}
                      items={itemCode.override_products}
                      size="auto"
                    />
                  </>
                ) : (
                  <></>
                )}
              </Grid>
              <Grid item xs={12}>
                <Stack direction="row" spacing={1} justifyContent="right">
                  <Button onClick={handleBack}>Cancel</Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => toggleConfirmModal()}
                  >
                    Save
                  </Button>
                </Stack>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default AddItemCode;
